import { Select } from 'antd';
import type { SelectProps } from 'antd';
import type { ReactElement } from 'react';
import { PiCheck } from 'react-icons/pi';
import { AntSelect, StyledSelect } from './styles/select.style';
import type { SelectStyleProps } from './styles/select.style';

type CompoundSelect = typeof Select & ((props: SelectProps & SelectStyleProps) => ReactElement);

const WDSelect = AntSelect(Select) as unknown as CompoundSelect;
const { Option, OptGroup } = Select;
const PlainSelect = StyledSelect(Select) as unknown as CompoundSelect;

const InternalWDSelect = (props: SelectProps & SelectStyleProps) => (
  <WDSelect
    {...props}
    menuItemSelectedIcon={props.mode === 'multiple' ? <PiCheck fontSize={16} /> : undefined}
  />
);

const Arrow = () => (
  <span className="ant-select-arrow custom-arrow" style={{ userSelect: 'none' }}>
    <i className="anticon anticon-down ant-select-arrow-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        data-icon="down"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" />
      </svg>
    </i>
  </span>
);

const WDSelectWithGlobalStyles = Object.assign(InternalWDSelect as unknown as CompoundSelect, {
  Option,
  OptGroup,
  Arrow,
});

export default WDSelectWithGlobalStyles;
export { OptGroup, Option, PlainSelect };
